<template>
  <CurrencyInput
      :options="{ currency: 'USD' }"
      v-bind:value="value"
      v-on:input="emitValue($event)"
      v-on:change="emitValue($event)"
      v-on:blur="emitValue($event)"
  />
</template>

<script>
import CurrencyInput from '../CurrencyInput'

export default {
  components: {CurrencyInput},
  props: {
    field: {},
    value: '',
  },
  methods: {
    emitValue(value) {
      this.$emit('filled-out', value);
    }
  }
}
</script>
